import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { State } from '~/Reducers';

export const REQUESTS_CHANGE_BATTLE_TYPE = 'REQUESTS_CHANGE_BATTLE_TYPE';
export const changeRequestsBattleType = (requestsBattleType: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: REQUESTS_CHANGE_BATTLE_TYPE,
    requestsBattleType
  })
};

export const REQUESTS_CHANGE_SEASON = 'REQUESTS_CHANGE_SEASON';
export const changeRequestsSeason = (requestsSeason: number): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: REQUESTS_CHANGE_SEASON,
    requestsSeason
  })
};

export const REQUESTS_CHANGE_SEASON_TYPE = 'REQUESTS_CHANGE_SEASON_TYPE';
export const changeRequestsSeasonType = (requestsSeasonType: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: REQUESTS_CHANGE_SEASON_TYPE,
    requestsSeasonType
  })
};


export const REQUESTS_CHANGE_TABS = 'REQUESTS_CHANGE_TABS';
export const changeRequestsTabs = (currentRequestsTab: number): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: REQUESTS_CHANGE_TABS,
    currentRequestsTab
  })
}